export const LANGUAGES = [
  { label: 'English', languageCode: 'en' },
  { label: 'Spanish', languageCode: 'es' },
  { label: 'Chinese', languageCode: 'zh' },
  { label: 'German', languageCode: 'de' },
  { label: 'French', languageCode: 'fr' },
  { label: 'Portuguese', languageCode: 'pt' },
  { label: 'Russian', languageCode: 'ru' }
]

export const LANGUAGE_CODES = ['en', 'es', 'zh', 'de', 'fr', 'pt', 'ru']

/* ==========================================================================
  HTTP Method Types
========================================================================== */
export const METHOD_TYPES = {
  get: 'get',
  post: 'post',
  put: 'put',
  delete: 'delete',
  patch: 'patch'
}

/* ==========================================================================
LocalStorage / Cookie data
========================================================================== */
export const TOKEN = 'no_limits_auth_token'
export const LANGUAGE = 'no_limits_language'
export const OPERATOR_ID = 'no_limits_operator_id'
export const ROLE = 'no_limits_operator_role'

/* ==========================================================================
  All the navigation route Paths
========================================================================== */
export const ROUTE_PATHS = {
  // ----single routes------------
  home: '/gamma-trade',
  predictionMarket: '/gamma-trade',
  predictionMarketMarkets: '/gamma-trade/markets',
  predictionMarketMarketDetail: '/gamma-trade/market-detail',
  predictionMarketPortfolio: '/gamma-trade/portfolio',
  // MarketInner: '/gamma-trade/:id'
}

/* ==========================================================================
Loader types
========================================================================== */
export const LOADER = {
  BUTTON: 'button',
  CONTENT: 'content',
  TABLE_CELL: 'tableCell',
  SPINNER: 'spinner'
}

/* ==========================================================================
  Loader Types
========================================================================== */
export const LOADER_HANDLER_TYPES = {
  page: 'pageLoader',
  submit: 'submitButtonLoader',
  table: 'tableLoader'
}

/* ==========================================================================
  Game Ids
========================================================================== */
export const DEFAULT_GAME_ID = {
  PredictionMarket: 2
}

/* ==========================================================================
  Game Result
========================================================================== */
export const BET_RESULT = {
  WON: 'won',
  LOST: 'lost',
  CANCELLED: 'cancelled'
}

export const S3_BUCKET_ENDPOINT =
  'https://gs-custom-games-storage.s3.amazonaws.com'

export const S3_BUCKET_ENDPOINT_FAST_GAMES =
  'https://fastgames-dev-storage.s3.amazonaws.com'

export const DEFAULT_PAGE_CALLS = 10

/* ==========================================================================
  Currency Symbols
========================================================================== */
export const CURRENCY_SYMBOL = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  INR: '₹',
  AED: 'إ.د',
  VND: '₫',
  IDR: 'Rp',
  PHP: '₱',
  JPY: '¥',
  KRW: '₩',
  RUB: '₽',
  MYR: 'RM',
  THB: '฿',
  BRL: 'R$',
  CNY: '¥',
  CAD: '$',
  MXN: '$',
  NGN: '₦',
  TRY: '₺',
  NZD: '$',
  AUD: '$',
  ARS: '$',
  ILS: '₪',
  UAH: '₴',
  PLN: 'zł'
}

export const transactionType = {
  PUBLIC_BETS: 'publicBets',
  LEADERBOARD: 'leaderboard',
  ACTIVE_BETS: 'activeBets',
  CLOSED_BETS: 'closedBets'
}

export const PROFIT_TYPE = {
  TAKE_PROFIT_AMOUNT: 'takeProfitAmount',
  PROFIT: 'profit'
}

export const BET_MODES = Object.freeze({
  MANUAL: 'manual',
  AUTO: 'auto',
  STRATEGY: 'strategy'
})

export const FEE_MODES = Object.freeze({
  PNL: 'pnl',
  FLAT: 'flat'
})

export const CHART_TYPES = Object.freeze({
  MOUNTAIN: 'mountain',
  CANDLE: 'candle'
})

export const PROFIT_TYPES = Object.freeze({
  PNL: 'PNL',
  ROI: 'ROI'
})

export const STOP_LOSS_TYPE = {
  STOP_LOSS_AMOUNT: 'stopLossAmount',
  STOP_LOSS: 'stopLoss'
}

export const CRYPTO_MIN_WAGER = 0.5

export const perArr = [
  -100, -50, -10, -5, -1, -0.5, -0.1, -0.05, -0.01, 0, 0.01, 0.05, 0.1, 0.48,
  0.95, 4.75, 9.5, 47.5, 95, 475, 950
]

export const menuData = [
  { id: 1, label: 'Trending', icon: '📈', active: true },
  { id: 2, label: 'Breaking' },
  { id: 3, label: 'New' },
  { id: 4, label: 'Politics' },
  { id: 5, label: 'Sports' },
  { id: 6, label: 'Finance' },
  { id: 7, label: 'Crypto' },
  { id: 8, label: 'Geopolitics' },
  { id: 9, label: 'Earnings' },
  { id: 10, label: 'Tech' },
  { id: 11, label: 'More', dropdown: true }
]

export const navigationData = {
  searchPlaceholder: 'Search Games',
  filters: [
    { id: 1, label: 'All', active: true },
    { id: 2, label: 'Trump' },
    { id: 3, label: 'Chile Election' },
    { id: 4, label: 'Epstein' },
    { id: 5, label: 'Venezuela' },
    { id: 6, label: 'Ukraine' },
    { id: 7, label: 'Best of 2025' },
    { id: 8, label: 'Mamdani' },
    { id: 9, label: 'Gemini 3' },
    { id: 10, label: 'China' }
  ]
}

export const DEFAULT_PAGE_SIZE = 10